// removed by extract-text-webpack-plugin
module.exports = {"contentCarousel":"_348PFnrfUT-vfcBPiTz2tW","link":"_3rSk_szN-gxL2KIJVWeR_d","content":"_2xzPFReltAYL_-ohAOsjSw","rowPos0":"_29SU2aIpw7QwPL9lCyTKt5","contentImg":"_1O4RM-0PtMxVlcls522IJN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/instagram-items/InstagramItems.css
// module id = 407
// module chunks = 0